import React from "react";
import {useLocation, useParams} from "react-router-dom";
import CampaignCreateEditService from "./CampaignCreateEditService";
import GenericTemplate from "../../../templates/GenericTemplate";
import {parseInt} from "lodash";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloPageUsagePermission} from "../../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";

/*
    画面名：キャンペーン作成（MS）
 */
const CampaignCreateMs: React.FC = () => {
    const {
        accountid,
        platformaccountid,
    } = useParams<{ accountgroupid: string, accountid: string, platformaccountid: string }>()

    const reqParams = new URLSearchParams(useLocation().search);
    
    const breadcrumbsData: BreadcrumbsData = {
        categoryId: 23,
        breadId: 2,
        queries: [],
        menu: {
            id: 2,
            accountId: platformaccountid,
            accountName: "",
        },
        campaign: null,
        adgroup: null,
        advertisement: null,
        asset: null,
    }

    return (
        <GenericTemplate title="">
            <CustomizedSnackbars/>
            <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
                <ApolloBreadcrumbs2 data={breadcrumbsData}/>
                <CampaignCreateEditService platformAccountId={parseInt(platformaccountid)} campaignId={0}/>
            </ApolloPageUsagePermission>
        </GenericTemplate>
    );
};

export default CampaignCreateMs;
